import React from 'react';
import axios from 'axios';
import { ExternalLink } from 'lucide-react';

const API = '';

const FacebookGroupCTA = ({ page }) => {
  return (
    <section className="py-10" data-testid="fb-group-cta-section">
      <div className="bg-white border border-slate-200 rounded-2xl p-6 md:p-8 flex flex-col md:flex-row items-center gap-6 shadow-sm">
        <div className="flex-shrink-0">
          <div className="w-14 h-14 rounded-xl bg-[#1877F2] flex items-center justify-center">
            <svg viewBox="0 0 24 24" className="h-7 w-7 text-white fill-current">
              <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
            </svg>
          </div>
        </div>
        <div className="flex-1 text-center md:text-left">
          <h3 className="text-lg font-bold text-slate-800 mb-1">Join the Discover Essex Community</h3>
          <p className="text-sm text-slate-600 leading-relaxed">
            Connect with local businesses, tradespeople, event organisers and professionals across Essex. 
            Promote your services, find trusted tradespeople, and discover what's happening locally.
          </p>
        </div>
        <a
          href="https://www.facebook.com/groups/discoveressexuk"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => {
            axios.post(`${API}/track-click`, {
              element: 'facebook_group',
              headline: 'Join the Discover Essex Community',
              subtext: page,
              cta_text: 'Join Facebook Group',
              cta_url: 'https://www.facebook.com/groups/discoveressexuk'
            }).catch(() => {});
          }}
          className="flex-shrink-0 inline-flex items-center gap-2 bg-[#1877F2] hover:bg-[#166FE5] text-white px-5 py-3 rounded-xl text-sm font-semibold transition-colors whitespace-nowrap"
          data-testid="fb-group-cta"
        >
          Join Facebook Group
          <ExternalLink className="h-4 w-4" />
        </a>
      </div>
    </section>
  );
};

export default FacebookGroupCTA;
